import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Snackbar, Toast } from '@chilecompra/react-kit'
import { onCloseSnackbar } from './SnackbarProvider.actions'

/**
 * The SnackbarProvider's container.
 */
const SnackbarProvider = () => {
  const dispatch = useDispatch()
  const { message, severity, showSnackbar } = useSelector(state => state.snackbarProvider)

  const handleCloseSnackbar = (_, reason) => {
    if (reason === 'clickaway') {
      return
    }
    dispatch(onCloseSnackbar())
  }

  return (
    showSnackbar && (
      <Snackbar open={showSnackbar} onClose={handleCloseSnackbar}>
        <Toast severity={severity} padding="6px 16px">
          {message}
        </Toast>
      </Snackbar>
    )
  )
}

export default SnackbarProvider
